const Subscribe = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <path
        d="M33.2151 4H10.9036C8.19328 4 6 6.22581 6 8.96886V37.2737C6 39.7931 8.7169 41.3449 10.8443 40.0434L21.5505 33.4961C21.7514 33.3727 22.0017 33.3727 22.2026 33.4928L27.7533 36.8115L33.304 40.1302C35.4347 41.4016 38.122 39.8465 38.122 37.3438V8.96886C38.1187 6.22581 35.9221 4 33.2151 4Z"
        stroke="#333333"
        strokeWidth="2.8"
      />
      <path
        d="M23.8766 18.9348H22.4766V20.3348V23.8291C22.4766 23.9678 22.422 24.0972 22.3307 24.1898C22.24 24.2817 22.121 24.3299 22.0008 24.3299C21.8806 24.3299 21.7616 24.2817 21.6709 24.1898C21.5796 24.0972 21.525 23.9679 21.525 23.8291V20.3348V18.9348H20.125H16.6766C16.5564 18.9348 16.4374 18.8866 16.3467 18.7947C16.2553 18.7022 16.2008 18.5728 16.2008 18.434C16.2008 18.2953 16.2553 18.1659 16.3467 18.0734C16.4374 17.9815 16.5564 17.9333 16.6766 17.9333H20.125H21.525V16.5333V13.0389C21.525 12.9002 21.5796 12.7708 21.6709 12.6783C21.7616 12.5864 21.8806 12.5382 22.0008 12.5382C22.1209 12.5382 22.24 12.5864 22.3307 12.6783C22.422 12.7708 22.4766 12.9002 22.4766 13.0389V16.5333V17.9333H23.8766H27.325C27.4452 17.9333 27.5642 17.9815 27.6549 18.0734C27.7462 18.1659 27.8008 18.2953 27.8008 18.434C27.8008 18.5728 27.7462 18.7022 27.6549 18.7947C27.5642 18.8866 27.4452 18.9348 27.325 18.9348H23.8766Z"
        stroke="#FC8037"
        strokeWidth="2.8"
      />
    </svg>
  )
}

export default Subscribe
